import type { BubblePointPressurePSIACalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const { oilAPI, solutionGasRsoAtReservoir } = params;
    const { gasSGat100psigSeparatorYg100, cnLtApi30, cnGtApi30 } =
      solutionGasRsoCalculator(params);

    // D264: =(J15/(0.05958*(D248^0.7972)*D252))^(1/1.0014)
    const bubblePointPressureAPILt30 =
      (solutionGasRsoAtReservoir /
        (0.05958 * gasSGat100psigSeparatorYg100 ** 0.7972 * cnLtApi30)) **
      (1 / 1.0014);

    // D266: =(J15/(0.0315*(D248^0.7587)*D258))^(1/1.0937)
    const bubblePointPressureAPIGt30 =
      (solutionGasRsoAtReservoir /
        (0.0315 * gasSGat100psigSeparatorYg100 ** 0.7587 * cnGtApi30)) **
      (1 / 1.0937);

    // D268: =IF(D11>0,D11,IF(D7>30,D266,D264))
    const bubblePointPressurePSIA =
      oilAPI > 30 ? bubblePointPressureAPIGt30 : bubblePointPressureAPILt30;
    return {
      bubblePointPressurePSIA,
      bubblePointPressureAPIGt30,
      bubblePointPressureAPILt30
    };
  };
